import { z } from 'zod'
import { ChampionshipStatistics, PublicShow } from './show-results-release.js'
import { PublicSeriesRef } from './series-publication.js'

const Year = z.number().int().min(1000).max(9999)
// Only the query arrives as text; the response keeps the strict year.
const QueryYear = z.coerce.number().pipe(Year)
const Count = z.number().int().nonnegative()
export const PublicChampionshipsQuery = z
  .strictObject({ fromYear: QueryYear.optional(), toYear: QueryYear.optional() })
  .refine(
    q =>
      (q.fromYear === undefined && q.toYear === undefined) ||
      (q.fromYear !== undefined &&
        q.toYear !== undefined &&
        q.toYear >= q.fromYear &&
        q.toYear - q.fromYear < 50),
    'Choose both years spanning at most 50 years.'
  )

export const PublicChampionshipEdition = z.strictObject({
  show: PublicShow,
  totals: z.strictObject({ entries: Count, entrants: Count, statesRepresented: Count }),
  states: ChampionshipStatistics.shape.states,
  unlocated: ChampionshipStatistics.shape.unlocated,
  classes: z.array(z.strictObject({ modelClassKey: z.string(), name: z.string(), entries: Count })),
  unlinkedEntries: Count,
})
export const PublicChampionshipsResponse = z.strictObject({
  series: PublicSeriesRef,
  fromYear: Year,
  toYear: Year,
  // Only years with released championships are returned; zero participation is still data.
  years: z.array(z.strictObject({ year: Year, editions: z.array(PublicChampionshipEdition) })),
  leaderboard: z.strictObject({
    contributingShows: Count,
    missingShows: Count,
    rows: z.array(
      z.strictObject({
        rank: z.number().int().positive(),
        entrant: z.string().min(1),
        points: z.number(),
        shows: z.number().int().positive(),
      })
    ),
  }),
})
export type PublicChampionshipsOutput = z.infer<typeof PublicChampionshipsResponse>
export type PublicChampionshipEditionOutput = z.infer<typeof PublicChampionshipEdition>
